import { Link } from 'react-router-dom'
import slice from 'lodash/slice'

import type { RouteDef, Blog } from '@ztechapps/common.contract'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { truncate } from '@ztechapps/common.utils'
import { WebuiIocKey, useInject } from '@ztechapps/webui.contract'
import { Tags } from '@ztechapps/webui.input'
import { LocalDateTime } from '@ztechapps/webui.date'
import { HorizontalStack } from '@ztechapps/webui.util'

import { BlogStatus } from '../BlogStatus'

const DataListRow = (props: BodyRowConfig<Blog>) => {
  const { _id, title, slug, summary, tags, updatedAt, status, category } = props
  const limitedTags = slice(tags, 0, 3)
  const blogItemRoute = useInject<RouteDef>(WebuiIocKey.routes.blogItem)
  const blogItemPath = blogItemRoute.altPath({ _id })

  return props._renderDataBodyCell({
    title: <Link to={blogItemPath}>{title}</Link>,
    slug: <div>{slug}</div>,
    summary: <div>{truncate(summary, 100)}</div>,
    tags: <Tags dataArray={limitedTags} />,
    updatedAt: <LocalDateTime value={updatedAt} />,
    category: <div>{category?.name}</div>,
    status: (
      <HorizontalStack gap={1}>
        <BlogStatus value={status} />
        <div>{status}</div>
      </HorizontalStack>
    ),
  })
}

export { DataListRow }
